// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.demographics_charts__zW0kI {
  display: grid;
  gap: var(--space-7) var(--space-8);
  grid-template-columns: minmax(0, 1fr);
}
.demographics_special__2XBdr {
  margin-top: clamp(3rem, 2rem + 3vw, 5rem);
  padding-top: var(--space-6);
  border-top: 1px solid var(--color-border);
}
.demographics_specialTitle__BEcEQ {
  margin: 0 0 var(--space-5);
  font-size: var(--text-h3);
  font-weight: 500;
}
.demographics_specialList__wmMp6 {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: var(--space-4);
  grid-template-columns: minmax(0, 1fr);
}
.demographics_specialList__wmMp6 li {
  padding: var(--space-5);
  background: var(--color-cloud);
  border-radius: var(--radius-md);
  border-top: 3px solid var(--kur-gold);
}
.demographics_specialList__wmMp6 strong {
  font-size: 1.15rem;
  font-weight: 500;
}
.demographics_specialList__wmMp6 p {
  margin: var(--space-2) 0 0;
  line-height: var(--leading-body);
  color: var(--color-text-muted);
}

@media (min-width: 900px) {
  .demographics_charts__zW0kI {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .demographics_specialList__wmMp6 {
    grid-template-columns: 1fr 1fr 2.5fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/PAGES/SPONSORS/SECTIONS/DEMOGRAPHICS/demographics.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kCAAkC;EAClC,qCAAqC;AACvC;AACA;EACE,yCAAyC;EACzC,2BAA2B;EAC3B,yCAAyC;AAC3C;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qCAAqC;AACvC;AACA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,+BAA+B;EAC/B,qCAAqC;AACvC;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE;IACE,gDAAgD;EAClD;EACA;IACE,oCAAoC;EACtC;AACF","sourcesContent":[".charts {\n  display: grid;\n  gap: var(--space-7) var(--space-8);\n  grid-template-columns: minmax(0, 1fr);\n}\n.special {\n  margin-top: clamp(3rem, 2rem + 3vw, 5rem);\n  padding-top: var(--space-6);\n  border-top: 1px solid var(--color-border);\n}\n.specialTitle {\n  margin: 0 0 var(--space-5);\n  font-size: var(--text-h3);\n  font-weight: 500;\n}\n.specialList {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: grid;\n  gap: var(--space-4);\n  grid-template-columns: minmax(0, 1fr);\n}\n.specialList li {\n  padding: var(--space-5);\n  background: var(--color-cloud);\n  border-radius: var(--radius-md);\n  border-top: 3px solid var(--kur-gold);\n}\n.specialList strong {\n  font-size: 1.15rem;\n  font-weight: 500;\n}\n.specialList p {\n  margin: var(--space-2) 0 0;\n  line-height: var(--leading-body);\n  color: var(--color-text-muted);\n}\n\n@media (min-width: 900px) {\n  .charts {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n  .specialList {\n    grid-template-columns: 1fr 1fr 2.5fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"charts": `demographics_charts__zW0kI`,
	"special": `demographics_special__2XBdr`,
	"specialTitle": `demographics_specialTitle__BEcEQ`,
	"specialList": `demographics_specialList__wmMp6`
};
export default ___CSS_LOADER_EXPORT___;
